import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Views } from '../enums/views.enum';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @Input() public title: string;
  @Input() public currentView: Views;

  @Output() public currentViewClick: EventEmitter<String> = new EventEmitter<String>();

  constructor() { }

  ngOnInit(): void {
  }

  public onLinksClicked() {
    this.onViewChanged( Views.LINKS );
  }

  public onPortfolioClicked() {
    this.onViewChanged( Views.PORTFOLIO );
  }

  private onViewChanged( view: Views ): void {
    this.currentView = view;
    console.log('#### view is ' + view );
    this.currentViewClick.emit( this.currentView );
  }
}
